'use strict';

require("core-js/modules/es.array.reduce.js");

module.exports = function (string) {
  var match = string.match(/^[ \t]*(?=\S)/gm);

  if (!match) {
    return 0;
  }

  return match.reduce(function (r, a) {
    return Math.min(r, a.length);
  }, Infinity);
};